import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: string;
  imageUrl: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categoryName,
  author,
  publishDate,
  readTime,
  imageUrl,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block cursor-pointer">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-2 flex-wrap">
          <Link
            to={`/category/${category}`}
            className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 hover:bg-primary-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400">{publishDate}</span>
          <span className="text-xs text-foreground-400">{readTime}</span>
        </div>
        <Link to={`/article/${slug}`} className="block cursor-pointer">
          <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center gap-2">
          <span className="text-xs text-foreground-400">{author}</span>
        </div>
      </div>
    </article>
  );
}